import React from "react";

interface DeletePopupProps {
  title: string;
  message: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const DeletePopup: React.FC<DeletePopupProps> = ({
  title,
  message,
  onCancel,
  onConfirm,
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center ">
      <div
        className="
          w-[90%] max-w-[503px] h-auto
          bg-white rounded-[12px]
          shadow-[0px_6px_24px_0px_rgba(0,0,0,0.15)]
          p-[24px] flex flex-col gap-4
        "
      >
        {/* Title */}
        <h2 className="text-xl font-semibold">{title}</h2>

        <div className="w-full border-t border-1px border-gray-200 mb-4"></div>

        {/* Message */}
        <p className="text-lg ">{message}</p>

        <div className="w-full border-t border-1px border-gray-200 mt-6"></div>

        {/* Buttons */}
        <div className="flex justify-end gap-[10px]">
          <button
            onClick={onCancel}
            className="
              w-[132px] h-[46px]
              rounded-[8px]
              border border-[#808191]
              bg-white
              px-[14px]
              text-gray-800
              
            "
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="
              w-[132px] h-[46px]
              rounded-[8px]
              bg-[#DB2A2A]
              px-[14px]
              text-white
             
            "
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeletePopup;
